import React from 'react';
import { IDisabled } from '../types';

const FilterIcon = ({ disabled }: IDisabled) => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className={disabled ? 'vbz-icon-beneficiaries-filter-disabled' : 'vbz-icon-beneficiaries-filter'} />
    </div>
  );
};

export default FilterIcon;
